const appContext = require('od-modules/xsell/config/app_context');
const logger = require('od-modules/utils/logger');
const HOTELS = appContext.products.HOTELS;
const CARS = appContext.products.CARS;
const MILLISECONDS_IN_DAY = 86400000;
const MILLISECONDS_IN_HOUR = 3600000;

function itineraryDates(itinerary, product) {
    const errorMessage = `unexpected itinerary type: ${itinerary.getItineraryType()}`;
    let itineraryDates = null;

    switch (itinerary.getItineraryType()) {
        case 'ONE_WAY':
            itineraryDates = oneWayDates(itinerary, product);
            break;
        case 'ROUND_TRIP':
            itineraryDates = defaultDates(itinerary);
            break;
        default:
            logger.message(errorMessage);
            throw new Error(errorMessage);
    }
    return applyDateLogicByProduct(itineraryDates, product);
}

function defaultDates(itinerary) {
    const that = {};

    that.arrival = isOngoingJourney(itinerary) ?
        ongoingJourneyDates(itinerary) :
        {
            arrivalDate: itinerary.getArrivalSegment().getArrivalLeg().getArrivalDate(),
            departureDate: itinerary.getArrivalSegment().getDepartureLeg().getDepartureDate(),
        };

    that.departure = {
        arrivalDate: itinerary.getDepartureSegment().getArrivalLeg().getArrivalDate(),
        departureDate: itinerary.getDepartureSegment().getDepartureLeg().getDepartureDate(),
    };

    return that;
}

function oneWayDates(itinerary, product) {
    const that = {};

    const arrivalDate = itinerary.getArrivalSegment().getArrivalLeg().getArrivalDate();
    const departureDate = itinerary.getArrivalSegment().getDepartureLeg().getDepartureDate();

    that.arrival = isOngoingJourney(itinerary) ? ongoingJourneyDates() : {arrivalDate, departureDate};

    const oneWayInboundDays = (product === HOTELS ? 3 : 7) * MILLISECONDS_IN_DAY;

    that.departure = {
        arrivalDate: departureDate + oneWayInboundDays,
        departureDate: arrivalDate + oneWayInboundDays,
    };

    return that;
}

function ongoingJourneyDates() {
    const now = new Date().getTime();

    return {
        arrivalDate: now + (MILLISECONDS_IN_HOUR * 4),
        departureDate: now + (MILLISECONDS_IN_HOUR * 2),
    };
}

function isOngoingJourney(itinerary) {
    const now = new Date();

    let start = 0;
    let end = 0;

    if (itinerary.isOneWay()) {
        start = new Date(itinerary.getArrivalSegment().getDepartureLeg().getDepartureDate());
        end = new Date(itinerary.getArrivalSegment().getArrivalLeg().getArrivalDate());
    } else {
        start = new Date(itinerary.getArrivalSegment().getArrivalLeg().getArrivalDate());
        end = new Date(itinerary.getDepartureSegment().getDepartureLeg().getDepartureDate());
    }

    return Odigeo.Utils.isDateInRange([start, end], now);
}

function applyDateLogicByProduct(itineraryDates, product) {
    if (product === CARS) {
        const arrivalDatePlusThirtyMinutes = Odigeo.Utils.addMins(itineraryDates.arrival.arrivalDate, 30);
        const departureDateMinusTwoHours = Odigeo.Utils.addHours(itineraryDates.departure.departureDate, -2);

        itineraryDates.arrival.arrivalDate = arrivalDatePlusThirtyMinutes;
        itineraryDates.departure.departureDate = departureDateMinusTwoHours;
    }

    return itineraryDates;
}

module.exports = itineraryDates;
